import { useState } from "react";
import { MovimientoContable, MovimientoContableEmitir } from "../models/consultaMovimientoContable";
import { getArchivo, getMovimientosContables as fetchMovimientosContables } from "../service/service";
import { useColumns } from "../utils/columns";
import { FiltroMovimientosContables } from "../page/consultarMovimientosContables";
import { StatusCode } from "../../../../utils/enums";
import { AxiosResponse } from "axios";

export function useMovimientoContable() {
    const [dataMovimiento, setDataMovimiento] = useState<MovimientoContable[]>([]);

    const getMovimientosContables = async (data: FiltroMovimientosContables) => {

        const response: AxiosResponse = await fetchMovimientosContables(data)
        if(response.status === StatusCode.Ok){
            setDataMovimiento(response.data)
        }else {
            setDataMovimiento([])
        }

    }

    return {
        getMovimientosContables,
        dataMovimiento,
    }
}